/**
 * @format
 */
export const TOGGLE_GLOBAL_LOADER = 'toggle_global_loader';
export const CHANGE_SEARCH_TEXT = 'change_search_text';
export const SET_SEARCHING_FOR = 'set_searching_for';
